<template>
    <div>
        <v-container fluid pa-0 class="h-100">
            <v-container fluid grid-list-xl class="toolbar-container">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <v-toolbar color="grey lighten-3" elevation="1">
                        <bc-btn-back></bc-btn-back>
                        <v-toolbar-title class="ml-0">Shipment</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <bc-modal-print
                            ref="print"
                            @close-method="(file_name = null), $refs.print.close()"
                            :file-name="file_name"
                            :no-button="true"
                        ></bc-modal-print>
                        <bc-btn-refresh v-if="shipment_planner.shipment_id && shipment_planner.shipment_id > 0" @invoke-method="refresh(true)"></bc-btn-refresh>
                        <v-menu left content-class="no-stripe" v-if="shipment_planner.shipment_id && shipment_planner.shipment_id > 0">
                            <template slot="activator">
                                <v-btn icon>
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-tile @click="printPDF()">
                                    <v-list-tile-title> Print </v-list-tile-title>
                                </v-list-tile>
                                <template v-if="hasPerm('shipment_planners.update')">
                                    <v-divider class="ml-3 my-0"></v-divider>

                                    <!-- <div v-for="item in shipment_planner_status_options" :key="item.option_id">
                                        <v-list-tile @click="changeStatus(item)" v-if="item.option_id != shipment_planner.status_id">
                                            <v-list-tile-title>
                                                {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                            </v-list-tile-title>
                                        </v-list-tile>
                                    </div> -->
                                    <div v-if="shipment_planner.status_id == 2 && shipment_planner.status_id != 6">
                                        <v-list-tile @click="changeStatus({ option_id: 1 })">
                                            <v-list-tile-title>
                                                {{ $t("lang.mark_as_draft") }}
                                            </v-list-tile-title>
                                        </v-list-tile>
                                    </div>
                                    <div v-if="shipment_planner.status_id != 6 && (shipment_planner.status_id == 1 || shipment_planner.status_id == 4)">
                                        <v-list-tile @click="changeStatus({ option_id: 2 })">
                                            <v-list-tile-title>
                                                {{ $t("lang.mark_as_in_route") }}
                                            </v-list-tile-title>
                                        </v-list-tile>
                                    </div>
                                    <div v-if="shipment_planner.status_id == 2 && shipment_planner.status_id != 6">
                                        <v-list-tile @click="changeStatus({ option_id: 4 })">
                                            <v-list-tile-title>
                                                {{ $t("lang.mark_as_delivered") }}
                                            </v-list-tile-title>
                                        </v-list-tile>
                                    </div>
                                    <div v-if="shipment_planner.status_id != 6">
                                        <v-list-tile @click="changeStatus({ option_id: 6 })">
                                            <v-list-tile-title>
                                                {{ $t("lang.cancel_shipment") }}
                                            </v-list-tile-title>
                                        </v-list-tile>
                                    </div>
                                </template>
                                <template v-if="hasPerm('shipment_planners.delete')">
                                    <v-divider class="ml-3 my-0"></v-divider>
                                    <v-list-tile @click="$refs.delete_shipment_planner.openDialog()">
                                        <v-list-tile-title> Delete </v-list-tile-title>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </v-menu>
                        <bc-tooltip>
                            <template slot="activator">
                                <v-btn icon @mouseup.left="$router.push({ name: 'shipment_planners' })">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </template>
                            {{ $t("lang.back_to_list") }}
                        </bc-tooltip>
                    </v-toolbar>
                </v-layout>
            </v-container>
            <v-card elevation="0" class="h-100">
                <v-card-text class="h-100">
                    <v-layout row :wrap="$bp.smallScreen">
                        <v-flex xs2 align-self-start pb-0 :pl-0="!$bp.smallScreen" pr-2 pt-2 class="clickable" @click="showShipment()">
                            <v-layout row wrap>
                                <v-flex py-1 class="text-center">
                                    <v-chip
                                        class="chip w-100 ml-auto mr-auto"
                                        style="width: fit-content"
                                        :color="shipment_planner.status_class"
                                        text-color="white"
                                        disabled
                                        >{{ shipment_planner.status }}</v-chip
                                    >
                                    <h2 class="display-0 mb-0 text-xs-center">{{ shipment_planner.company }}</h2>
                                    <v-img :src="selectedCustomer.logo" height="150px" width="150px" class="rounded-circle mx-auto"></v-img>
                                </v-flex>
                            </v-layout>
                            <v-divider class="my-0"></v-divider>

                            <!-- END CELL INFO -->
                            <bc-list prepend-icon="list" prepend-position="top" icon-color="primary">
                                <template>
                                    <v-container pa-0>
                                        <v-layout row wrap>
                                            <v-flex xs6 mt-1>{{ `${$t("lang.truck")}:` }}</v-flex>
                                            <v-flex xs6 fw-bold mt-1>{{ shipment_planner.truck_name ? shipment_planner.truck_name : "---" }}</v-flex>
                                            <v-flex xs6 mt-1>{{ `${$t("lang.trailer")}:` }}</v-flex>
                                            <v-flex xs6 fw-bold mt-1>{{ shipment_planner.trailer_name ? shipment_planner.trailer_name : "---" }}</v-flex>
                                            <v-flex xs6 mt-1>{{ `${$t("lang.load_date")}:` }}</v-flex>
                                            <v-flex xs6 fw-bold mt-1>{{ shipment_planner.load_date ? shipment_planner.load_date : "---" }}</v-flex>

                                            <v-flex xs6 mt-1>{{ `${$t("lang.deliver_date")}:` }}</v-flex>
                                            <v-flex xs6 fw-bold mt-1>{{ shipment_planner.deliver_date ? shipment_planner.deliver_date : "---" }}</v-flex>

                                            <v-flex xs6 mt-1>{{ `${$t("lang.delivered_by")}:` }}</v-flex>
                                            <v-flex xs6 fw-bold mt-1>{{
                                                shipment_planner.delivered_by_name ? shipment_planner.delivered_by_name : "---"
                                            }}</v-flex>
                                        </v-layout>
                                    </v-container>
                                </template>
                            </bc-list>
                        </v-flex>
                        <v-divider vertical class="mt-0 mb-0" inset v-if="!$bp.smallScreen"></v-divider>
                        <v-flex xs2 class="h-100 pa-2">
                            <h4 class="mb-0">Pending Deliveries</h4>
                            <v-divider></v-divider>
                            <div v-if="transaction_documents.length <= 0 || refresh_documents == true" style="height: calc(100vh - 290px)">
                                <v-alert class="w-100 ma-auto" :value="true" :color="refresh_documents == true ? 'primary' : 'grey'" type="info">{{
                                    refresh_documents == true ? "Refreshing Orders..." : "No Pending Deliveries"
                                }}</v-alert>
                            </div>

                            <vue-perfect-scrollbar v-else style="height: calc(100vh - 290px)">
                                <transition-group name="list" tag="div">
                                    <div
                                        v-for="(n, index) in transaction_documents"
                                        v-if="
                                            n.transaction_document_details &&
                                            (n.transaction_document_details != null || n.transaction_document_details.length > 0)
                                        "
                                        :key="index"
                                        class="pr-2 pt-2"
                                    >
                                        <v-layout row wrap style="background-color: lightgray" class="pa-2">
                                            <v-flex xs8
                                                ><label>{{ n.ship_city }}, {{ n.ship_state }}</label></v-flex
                                            >
                                            <v-flex xs4>
                                                <small class="ml-auto">{{ n.due_date }}</small>
                                            </v-flex>
                                            <v-flex xs12
                                                ><span class="fs-14">{{ n.ship_location_label }}</span></v-flex
                                            >
                                        </v-layout>
                                        <drag
                                            v-for="(detail, index) in n.transaction_document_details"
                                            :key="index"
                                            class="drag pa-2"
                                            :data="detail"
                                            @cut="removeFromOrder(n, detail)"
                                            :goBack="true"
                                            :style="{ backgroundColor: `#${detail.color}` }"
                                        >
                                            <v-layout row wrap>
                                                <v-flex xs6>
                                                    <h5>{{ detail.product_name }}</h5>
                                                </v-flex>
                                                <v-flex xs6>
                                                    <small :style="{ textAlign: 'end' }"
                                                        >{{ $isSet(detail.quantity) ? detail.quantity : detail.quantity_ordered }}G</small
                                                    >
                                                </v-flex>
                                            </v-layout>
                                        </drag>
                                    </div>
                                </transition-group>
                            </vue-perfect-scrollbar>
                        </v-flex>
                        <v-divider vertical class="mt-0 mb-0" inset v-if="!$bp.smallScreen"></v-divider>
                        <v-flex xs8 class="h-100 pa-2">
                            <h4 class="mb-0">Compartments</h4>
                            <v-divider></v-divider>
                            <v-layout row wrap class="pa-0">
                                <v-flex xs2 class="mr-2 h-100 pa-0" v-for="compart_num in range(1, shipment_planner.num_of_compartments)" :key="compart_num">
                                    <drop
                                        :id="compart_num"
                                        class=""
                                        style="background: lightgray; height: 100%; min-height: 384px; position: relative"
                                        @drop="onDrop"
                                        mode="cut"
                                        :accepts-data="
                                            (data) =>
                                                shipment_planner.shipment_planner_details.filter((detail) => detail.compartment == compart_num).length < 1
                                                    ? true
                                                    : shipment_planner.shipment_planner_details.filter((detail) => detail.compartment == compart_num)[0]
                                                          .product_id == data.product_id
                                        "
                                    >
                                        <h4 style="font-size: 196px; color: gray; position: absolute" class="text-center w-100">{{ compart_num }}</h4>
                                        <drag
                                            v-for="(detail, index) in shipment_planner.shipment_planner_details.filter(
                                                (detail) => detail.compartment == compart_num
                                            )"
                                            :key="index"
                                            class="drag"
                                            :data="detail"
                                            @cut="removeFromCompartment(detail, compart_num)"
                                            :goBack="true"
                                            :style="{ backgroundColor: `#${detail.color}`, zIndex: 1, position: 'relative' }"
                                        >
                                            <v-layout row wrap class="pa-2">
                                                <v-flex xs9>
                                                    <h5>{{ detail.product_name }}</h5>
                                                </v-flex>
                                                <v-flex xs3>
                                                    <small :style="{ textAlign: 'end' }">{{ detail.quantity_ordered }}G</small>
                                                </v-flex>
                                                <v-flex xs11 class="pr-2">
                                                    <v-text-field
                                                        class="small-text-field fs-12"
                                                        v-model="detail.quantity_delivered"
                                                        placeholder="Quantity to Deliver"
                                                        outline
                                                        hide-details
                                                        @input="calculateCompartment(compart_num)"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs1>
                                                    <v-icon @click="removeFromCompartment(detail, compart_num, true)">delete</v-icon>
                                                </v-flex>
                                            </v-layout>
                                        </drag>
                                    </drop>
                                    <v-layout row wrap class="pa-2" style="background: gray">
                                        <v-flex xs6 style="color: white">Gallons</v-flex>
                                        <v-flex xs6 class="text-right" :id="compart_num + '_gallons'" style="color: white">0</v-flex>
                                        <v-flex xs6 style="color: white">Weight</v-flex>
                                        <v-flex xs6 class="text-right" :id="compart_num + '_weight'" style="color: white">0 lbs</v-flex>
                                        <v-flex xs6 style="color: white">Capacity</v-flex>
                                        <v-flex xs6 class="text-right" :id="compart_num + '_capacity'" style="color: white">{{
                                            formatNumberWithCommas(parseInt(shipment_planner["compartment" + compart_num]))
                                        }}</v-flex>
                                        <v-flex xs6 style="color: white">Remaining</v-flex>
                                        <v-flex xs6 class="text-right" :id="compart_num + '_remaining'" style="color: white">{{
                                            formatNumberWithCommas(parseInt(shipment_planner["compartment" + compart_num]))
                                        }}</v-flex>
                                    </v-layout>
                                </v-flex>

                                <v-flex xs12>
                                    <v-divider></v-divider>
                                    <v-layout row wrap>
                                        <v-flex xs2>
                                            <span>Total Gallons: <strong id="total_gallons">0 lbs</strong></span>
                                        </v-flex>
                                        <v-flex xs2>
                                            <span
                                                >Max Payload:
                                                <strong>{{
                                                    shipment_planner.payload ? `${formatNumberWithCommas(parseInt(shipment_planner.payload))} lbs` : "0 lbs"
                                                }}</strong></span
                                            >
                                        </v-flex>
                                        <v-flex xs2>
                                            <span>Total Weight: <strong id="total_weight">0 lbs</strong></span>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @mouseup.left="$router.push({ name: 'shipment_planners' })" flat>{{ $t("lang.cancel") }}</v-btn>
                    <v-btn
                        v-if="hasPerm('shipment_planners.update')"
                        :disabled="
                            canSave ||
                            shipment_planner.has_products == 0 ||
                            shipment_planner.shipment_planner_details == null ||
                            shipment_planner.shipment_planner_details.length == 0
                        "
                        color="primary"
                        @click="gotoFinalizeShipment()"
                        >{{ $t("lang.finalize_shipment") }}</v-btn
                    >
                    <v-btn :disabled="canSave" color="success" @click="saveShipmentPlanners">{{ $t("lang.save") }}</v-btn>
                </v-card-actions>
            </v-card>

            <bc-dialog v-if="shipment_planner_dialog == true" :value="shipment_planner_dialog">
                <v-card>
                    <v-form ref="form_shipment_planner">
                        <v-card-title>
                            <span class="headline">{{ $t("lang.edit_shipment_planner") }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeShipmentPlannerDialog"
                                :dialog-status="shipment_planner_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="shipment_planner.company_id"
                                            :label="$t('lang.company')"
                                            :rules="ifValid('shipment_planners.company_id')"
                                            :items="company_options"
                                            item-value="company_id"
                                            item-text="company"
                                            :disabled="true"
                                            append-icon="lock"
                                        >
                                        </bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12 v-if="shipment_planner.company_id">
                                        <bc-autocomplete
                                            v-model="shipment_planner.truck_id"
                                            :label="$t('lang.truck')"
                                            :items="filterTrucks"
                                            item-value="truck_id"
                                            item-text="truck_name"
                                            :rules="ifValid('shipment_planners.truck_id')"
                                            :disabled="shipment_planner.has_products == 1 ? true : false"
                                            :append-icon="shipment_planner.has_products == 1 ? 'lock' : 'arrow_drop_down'"
                                            @change="changeTrailer()"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12 v-if="shipment_planner.company_id && checkTruckCompartments">
                                        <bc-autocomplete
                                            v-model="shipment_planner.trailer_id"
                                            :label="$t('lang.trailer')"
                                            :items="filterTrailers"
                                            item-value="truck_id"
                                            item-text="truck_name"
                                            :rules="ifValid('shipment_planners.trailer_id')"
                                            :disabled="shipment_planner.has_products == 1 ? true : false"
                                            :append-icon="shipment_planner.has_products == 1 ? 'lock' : 'arrow_drop_down'"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs6>
                                        <bc-date-picker
                                            class="mt-auto"
                                            v-model="shipment_planner.load_date"
                                            :label="`${$t('lang.load_date')}`"
                                            :rules="ifValid('shipment_planners.load_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs6>
                                        <bc-date-picker
                                            class="mt-auto"
                                            v-model="shipment_planner.deliver_date"
                                            :label="`${$t('lang.deliver_date')}`"
                                            :rules="ifValid('shipment_planners.deliver_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="shipment_planner.delivered_by"
                                            :label="$t('lang.delivered_by')"
                                            :items="drivers"
                                            item-value="people_id"
                                            item-text="combined_name"
                                            :rules="ifValid('shipment_planners.delivered_by')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeShipmentPlannerDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="saveShipmentPlanners">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>

            <delete-confirmation-dialog
                ref="delete_shipment_planner"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_shipment_planner')"
                :message="$t('lang.delete_shipment_planner_confirm')"
                @onConfirm="deleteShipmentPlanners()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_shipment_planner_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteShipmentPlannerDetails()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { Container, Draggable } from "vue-dndrop";
import _ from "lodash";
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";
import { Drag, Drop, DropMask } from "vue-easy-dnd";

export default {
    components: {
        Drag,
        Drop,
        DropMask,
        Container,
        Draggable,
    },
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],

            formData: {},
            shipment_planner: {},
            file_name: "",
            dbGetShipmentPlanner: _.debounce(this.getShipmentPlanner, 1500, { maxWait: 1500, leading: true, trailing: false }),
            customers: null,
            tanker_truck: {},
            loads: [],
            transaction_documents: [],
            shipment_planner_dialog: false,
            drivers: [],
            tanker_trailer: {},
            canSave: false,
            stopSave: [],
            refresh_documents: true,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;
        this.$store.commit("toggleMainMenu", false);
        if (id !== "undefined") {
            this.$store
                .dispatch("fetchShipmentPlanner", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.shipment_planner) {
                        this.shipment_planner = this.assignObj2(data.shipment_planner, this.rules_shipment_planners);
                        if (this.shipment_planner.shipment_planner_details == null) this.shipment_planner.shipment_planner_details = [];

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=shipment_planner_status&sort_by=2",
                            method: "get",
                            stateProperty: "shipment_planner_status_options",
                            dataProperty: "options",
                            commit: true,
                        });
                        this.refresh();
                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "shipment_planners", replace: true });
                    }
                });
        } else {
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            const id = `${to.params.id}`;
            vm.$store.commit("toggleMainMenu", false);
            if (id !== "undefined") {
                store
                    .dispatch("fetchShipmentPlanner", {
                        id: id,
                    })
                    .then((data) => {
                        if (typeof data !== "undefined" && data.shipment_planner) {
                            vm.shipment_planner = vm.assignObj2(data.shipment_planner, vm.rules_shipment_planners);
                            if (vm.shipment_planner.shipment_planner_details == null) vm.shipment_planner.shipment_planner_details = [];

                            store.dispatch("fetchSetting", {
                                url: "options?slug=shipment_planner_status&sort_by=2",
                                method: "get",
                                stateProperty: "shipment_planner_status_options",
                                dataProperty: "options",
                                commit: true,
                            });
                            vm.refresh();
                            vm.finishLoader();
                        } else {
                            next({ name: "shipment_planners", replace: true });
                        }
                    });
            } else {
                vm.finishLoader();
            }
        });
    },
    computed: {
        ...mapState({
            rules_shipment_planners: (state) => state.shipment_planners.rules_shipment_planners,
            shipment_planner_status_options: (state) => state.settings.shipment_planner_status,
            shipment_planners: (state) => state.shipment_planners.shipment_planners,
            selectedShipmentPlanner: (state) => state.shipment_planners.selectedShipmentPlanner,
            tanker_trucks: (state) => state.tanker_trucks.tanker_truck_options,
            selectedCustomer: (state) => state.customers.selectedCustomer,
            current_docs: (state) => state.transaction_documents.transaction_document_options,
            company_options: (state) => state.companies.company_options,
        }),
        filterTrucks() {
            return this.tanker_trucks.length > 0
                ? this.tanker_trucks.filter((truck) => truck.company_id == this.shipment_planner.company_id && truck.vehicle_type == "truck")
                : [];
        },
        filterTrailers() {
            return this.tanker_trucks.length > 0
                ? this.tanker_trucks.filter((truck) => truck.company_id == this.shipment_planner.company_id && truck.vehicle_type == "trailer")
                : [];
        },
        checkTruckCompartments() {
            return this.tanker_trucks.find((truck) => truck.truck_id == this.shipment_planner.truck_id).num_of_compartments > 0 ? false : true;
        },
        checkTrailerCompartments() {
            return this.tanker_trucks.length > 0 ? this.tanker_trucks.find((truck) => truck.truck_id == this.shipment_planner.trailer_id) : [];
        },
    },
    methods: {
        ...mapActions([
            "fetchShipmentPlanner",
            "saveShipmentPlanner",
            "deleteShipmentPlanner",
            "printShipmentPlanner",
            "fetchTankerTrucks",
            "fetchTransactionDocuments",
            "fetchCustomer",
            "validationOn",
            "fetchCompanies",
            "fetchPeople",
        ]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        onDrop(e) {
            if (this.shipment_planner.shipment_planner_details == null) this.shipment_planner.shipment_planner_details = [];
            let details = this.shipment_planner.shipment_planner_details.filter((detail) => e.top.$el.id == detail.compartment);
            if (details.length > 0) {
                // if (details.filter((detail) => detail.product_id == e.data.product_id).length > 0) return;
                let canAdd = true;
                for (let i = 0; i < details.length; i++) {
                    if (details[i].product_id != e.data.product_id) {
                        canAdd = false;
                    }
                }

                let document = this.transaction_documents.find((doc) => doc.document_id == e.data.document_id);
                if (canAdd) {
                    this.shipment_planner.shipment_planner_details.push({
                        ...e.data,
                        quantity_ordered: this.$isSet(e.data.quantity) ? e.data.quantity : e.data.quantity_ordered,
                        quantity_delivered: this.$isSet(e.data.quantity) ? e.data.quantity : e.data.quantity_delivered,
                        compartment: e.top.$el.id,
                        ship_address1: document.ship_address1,
                        ship_address2: document.ship_address2,
                        ship_city: document.ship_city,
                        ship_state: document.ship_state,
                        ship_zip_code: document.ship_zip_code,
                        ship_zip_code_ext: document.ship_zip_code_ext,
                        ship_location_label: document.ship_location_label,
                        shipping_address_id: document.shipping_address_id,
                        ship_country_iso_3: document.ship_country_iso_3,
                        company_id: document.company_id,
                    });
                } else {
                    return;
                }
            } else {
                let document = this.transaction_documents.find((doc) => doc.document_id == e.data.document_id);
                this.shipment_planner.shipment_planner_details.push({
                    ...e.data,
                    quantity_ordered: this.$isSet(e.data.quantity) ? e.data.quantity : e.data.quantity_ordered,
                    quantity_delivered: this.$isSet(e.data.quantity) ? e.data.quantity : e.data.quantity_delivered,
                    compartment: e.top.$el.id,
                    ship_address1: document.ship_address1,
                    ship_address2: document.ship_address2,
                    ship_city: document.ship_city,
                    ship_state: document.ship_state,
                    ship_zip_code: document.ship_zip_code,
                    ship_zip_code_ext: document.ship_zip_code_ext,
                    ship_location_label: document.ship_location_label,
                    shipping_address_id: document.shipping_address_id,
                    ship_country_iso_3: document.ship_country_iso_3,
                    company_id: document.company_id,
                });
            }
        },
        removeFromOrder(doc, detail) {
            this.transaction_documents
                .find((doc) => doc.document_id == detail.document_id)
                .transaction_document_details.splice(
                    this.transaction_documents
                        .find((doc) => doc.document_id == detail.document_id)
                        .transaction_document_details.findIndex((product) => product.product_id == detail.product_id),
                    1
                );

            if (this.transaction_documents.find((doc) => doc.document_id == detail.document_id).transaction_document_details.length == 0) {
                this.transaction_documents.splice(
                    this.transaction_documents.findIndex((doc) => doc.document_id == detail.document_id),
                    1
                );
            }

            this.$nextTick(() => {
                for (let i = 1; i <= parseInt(this.shipment_planner.num_of_compartments); i++) {
                    this.calculateCompartment(i);
                }
            });
        },
        removeFromCompartment(detail, compart_num, back_to_doc = false) {
            // if detail is dropped on the same compartment its already in, don't remove it
            this.shipment_planner.shipment_planner_details.splice(
                this.shipment_planner.shipment_planner_details.findIndex((product) => product.document_detail_id == detail.document_detail_id),
                1
            );

            if (back_to_doc) {
                if (this.transaction_documents.find((doc) => doc.document_id == detail.document_id)) {
                    if (!this.transaction_documents.find((doc) => doc.document_id == detail.document_id).transaction_document_details) {
                        this.transaction_documents.find((doc) => doc.document_id == detail.document_id).transaction_document_details = [];
                    }
                    this.transaction_documents.find((doc) => doc.document_id == detail.document_id).transaction_document_details.push(detail);
                } else {
                    let doc = this.current_docs.find((doc) => doc.document_id == detail.document_id);
                    this.transaction_documents.push(JSON.parse(JSON.stringify(doc)));
                    this.transaction_documents.find((doc) => doc.document_id == detail.document_id).transaction_document_details = [];
                    this.transaction_documents.find((doc) => doc.document_id == detail.document_id).transaction_document_details.push(detail);
                }
            }

            this.$nextTick(() => {
                for (let i = 1; i <= parseInt(this.shipment_planner.num_of_compartments); i++) {
                    this.calculateCompartment(i);
                }
            });
        },
        calculateCompartment(compartment) {
            let trailer_compartments = parseInt(this.shipment_planner.num_of_compartments);
            if (this.stopSave.length >= trailer_compartments + 1) {
                this.stopSave = [];
            }
            let gallons = 0;
            let weight = 0;
            let remaining = parseInt(document.getElementById(compartment + "_capacity").innerText.replace(/,/g, ""));
            if (this.shipment_planner.shipment_planner_details.filter((detail) => detail.compartment == compartment).length > 0) {
                this.shipment_planner.shipment_planner_details
                    .filter((detail) => detail.compartment == compartment)
                    .forEach((detail) => {
                        gallons += parseInt(detail.quantity_delivered);
                        weight += detail.quantity_delivered * (detail.specific_gravity * 8.34);
                    });
            }
            remaining -= gallons;
            document.getElementById(compartment + "_gallons").innerText = gallons.toLocaleString("en-US");
            document.getElementById(compartment + "_weight").innerHTML = Math.round(weight).toLocaleString("en-US") + " lbs";
            document.getElementById(compartment + "_remaining").innerText = remaining.toLocaleString("en-US");

            if (Math.round(remaining) < 0) {
                if (!$("#" + compartment + "_remaining").hasClass("red-color")) {
                    $("#" + compartment + "_remaining").toggleClass("red-color");
                }
                this.stopSave.push(1);
            } else {
                if ($("#" + compartment + "_remaining").hasClass("red-color")) {
                    $("#" + compartment + "_remaining").toggleClass("red-color");
                }
                this.stopSave.push(0);
            }

            let totalGallons = 0;
            if (this.shipment_planner.shipment_planner_details.length > 0) {
                this.shipment_planner.shipment_planner_details.forEach((detail) => {
                    totalGallons += parseInt(detail.quantity_delivered);
                    document.getElementById("total_gallons").innerText = totalGallons.toLocaleString("en-US");
                });
            } else {
                document.getElementById("total_gallons").innerText = 0;
            }

            let product_weight = 0;
            for (let i = 1; i <= this.shipment_planner.num_of_compartments; i++) {
                product_weight += parseInt(
                    document
                        .getElementById(i + "_weight")
                        .innerHTML.split(" ")[0]
                        .replace(/,/g, "")
                );
            }

            let total_weight = 0;
            let payload = parseInt(this.shipment_planner.payload);
            total_weight = product_weight;
            if (total_weight > payload) {
                if (!$("#total_weight").hasClass("red-color")) {
                    $("#total_weight").toggleClass("red-color");
                }
                this.stopSave.push(1);
            } else {
                if ($("#total_weight").hasClass("red-color")) {
                    $("#total_weight").toggleClass("red-color");
                }
                this.stopSave.push(0);
            }
            document.getElementById("total_weight").innerHTML = Math.round(total_weight).toLocaleString("en-US") + " lbs";
            if (trailer_compartments === compartment) {
                if (this.stopSave.includes(1)) {
                    this.canSave = true;
                } else {
                    this.canSave = false;
                }
            }
        },
        getShipmentPlanner(pg_refresh = false) {
            this.startLoader();

            this.fetchShipmentPlanner({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.shipment_planner) {
                    this.shipment_planner = this.assignObj2(data.shipment_planner, this.rules_shipment_planners);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printShipmentPlanner({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data != "undefined" && data.shipment_planner) {
                    if (this.dev_mode) {
                        this.file_name = data.shipment_planner.file_name;
                    } else {
                        this.$refs.print.printReport(data.shipment_planner.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveShipmentPlanners() {
            this.validationOn();
            this.$nextTick(() => {
                let body = this.prepForm(this.shipment_planner, this.rules_shipment_planners);

                this.saveShipmentPlanner({
                    body: body,
                }).then((data) => {
                    if (typeof data != "undefined" && data.shipment_planner) {
                        this.shipment_planner = this.assignObj2(data.shipment_planner, this.rules_shipment_planners);
                        if (this.shipment_planner.shipment_planner_details == null) this.shipment_planner.shipment_planner_details = [];
                        this.shipment_planner_dialog = false;
                        this.validationOff();
                    } else {
                    }
                });
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { shipment_id: `${this.$route.params.id}`, status_id: item.option_id };

            this.saveShipmentPlanner({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.shipment_planner) {
                    this.shipment_planner = this.assignObj2(data.shipment_planner, this.rules_shipment_planners);
                    if (this.shipment_planner.shipment_planner_details == null) this.shipment_planner.shipment_planner_details = [];
                    this.status_loader = false;
                }
            });
        },
        deleteShipmentPlanners() {
            this.deleteShipmentPlanner({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.validationOff();
                    this.$router.push({ name: "shipment_planners" });
                }
                this.toggleModalLoader(false);
            });
        },
        range(min, max) {
            var array = [],
                j = 0;
            for (var i = min; i <= max; i++) {
                array[j] = i;
                j++;
            }
            return array;
        },
        getDrivers(company_id) {
            this.fetchPeople({ body: { options: 1, company_id: company_id } }).then((data) => {
                if (typeof data !== "undefined" && data.people) {
                    this.drivers = data.people;

                    if (this.shipment_planner.delivered_by) {
                        this.shipment_planner.delivered_by = this.drivers.find((driver) => driver.people_id == this.shipment_planner.delivered_by).people_id;
                    }
                }
            });
        },
        async refresh(force = false) {
            this.startLoader();
            this.refresh_documents = true;

            if (force == true) {
                await this.fetchShipmentPlanner({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.shipment_planner) {
                        this.shipment_planner = this.assignObj2(data.shipment_planner, this.rules_shipment_planners);
                        if (this.shipment_planner.shipment_planner_details == null) this.shipment_planner.shipment_planner_details = [];
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            } else {
                this.finishLoader();
            }

            if (this.tanker_trucks.length == 0 || force == true) {
                await this.fetchTankerTrucks({ body: { options: 1 } }).then((data) => {
                    if (typeof data !== "undefined" && data.tanker_trucks) {
                        this.tanker_truck = this.tanker_trucks.find((truck) => truck.truck_id == this.shipment_planner.truck_id);
                        this.tanker_trailer = this.tanker_trucks.find((truck) => truck.truck_id == this.shipment_planner.trailer_id);
                    }
                });
            } else {
                this.tanker_truck = this.tanker_trucks.find((truck) => truck.truck_id == this.shipment_planner.truck_id);
                this.tanker_trailer = this.tanker_trucks.find((truck) => truck.truck_id == this.shipment_planner.trailer_id);
            }

            if (this.shipment_planner.company_id) {
                this.fetchCustomer({
                    id: this.shipment_planner.company_id,
                });
            }

            if (this.company_options.length == 0 || force == true) await this.fetchCompanies({ body: { options: 1 } });

            if (this.drivers.length == 0 || force == true) {
                this.getDrivers(this.shipment_planner.company_id);
            }

            // iterate through the transaction_documents and remove the one that has been added to the shipment_planner

            if (this.transaction_documents.length == 0 || force == true) {
                await this.fetchTransactionDocuments({
                    body: { company_id: this.shipment_planner.company_id, status: "open", options: 1, not_shipped: 1 },
                }).then((data) => {
                    if (typeof data !== "undefined" && data.transaction_documents) {
                        this.transaction_documents = JSON.parse(JSON.stringify(data.transaction_documents));
                    }
                });
            }
            setTimeout(() => {
                this.refresh_documents = false;
            }, 1000);
        },
        showShipment() {
            this.shipment_planner_dialog = true;
        },
        closeShipmentPlannerDialog() {
            this.shipment_planner_dialog = false;
            this.validationOff();
            this.toggleModalLoader(false);
        },
        formatNumberWithCommas(number) {
            return number.toLocaleString("en-US");
        },
        changeTrailer() {
            this.shipment_planner.delivered_by = this.tanker_trucks.find((truck) => truck.truck_id == this.shipment_planner.truck_id).driver_id;
            if (this.tanker_trucks.filter((truck) => truck.truck_id == this.shipment_planner.truck_id)[0].num_of_compartments > 0) {
                this.shipment_planner.trailer_id = null;
            }
        },
        gotoFinalizeShipment() {
            this.validationOn();
            this.$nextTick(() => {
                let body = this.prepForm(this.shipment_planner, this.rules_shipment_planners);

                this.saveShipmentPlanner({
                    body: body,
                }).then((data) => {
                    if (typeof data != "undefined" && data.shipment_planner) {
                        this.validationOff();
                        this.$router.push({ name: "shipment_planner_finalize", params: { id: this.$route.params.id } });
                    } else {
                    }
                });
            });
        },
    },
    created() {},
};
</script>
<style>
.mask {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border: 1px solid black;
    background-color: rgba(255, 0, 0, 0.2);
    width: 200px;
    height: 100px;
}

.mask::before {
    content: "MASK";
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: rgba(0, 0, 0, 0.4);
    font-size: 25px;
    font-weight: bold;
}

.drop-allowed {
    background-color: rgba(0, 255, 0, 0.2);
}

.drop-forbidden {
    background-color: rgba(255, 0, 0, 0.2);
}

.drop-in {
    box-shadow: 0 0 5px rgba(0, 0, 255, 0.4);
}

.list-enter,
.list-leave-to {
    opacity: 0;
}

.list-leave-active {
    position: absolute;
}

.small-text-field.v-text-field--outline > .v-input__control > .v-input__slot {
    min-height: 28px !important;
    background-color: white !important;
    padding: 0 4px !important;
}

.small-text-field.v-text-field--outline input {
    margin-top: 0px !important;
    background-color: white !important;
    text-align: left;
}

.red-color {
    color: red !important;
}

.white-color {
    color: white !important;
}
</style>
